import { onError } from 'apollo-link-error';

function captureMessage(message, extra) {
  window.Raven.captureMessage(message, {
    extra: {
      ...extra,
    },
    // Allows searching Sentry issues for all Apollo/GraphQL errors.
    logger: 'apollo-link-error',
    tags: {
      // Allows searching Sentry issues by a specific GraphQL operation.
      'graphql.operation.name': extra.operation.operationName,
    },
  });
}

export default function createErrorLink(getRouter) {
  return onError(function({
    graphQLErrors,
    networkError,
    response,
    operation,
  }) {
    // If sentry is on the page send the errors to sentry
    if (window.Raven) {
      if (graphQLErrors) {
        graphQLErrors.map(({ message, locations, path }) => {
          captureMessage(message, {
            locations,
            path,
            operation,
            response,
          });
        });
      }

      if (networkError) {
        captureMessage(networkError, {
          operation: { operationName: 'NETWORK' },
        });
      }
    }

    // Route to the mover app's main error page.
    getRouter().goToError();
  });
}
